import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css``

const developerCSS = css``

export const AssetsSelectorCSS = styled.div`
  width: 100%;
  display: grid;
  grid-template: 1fr / 1fr auto;
  ${designerCSS} ${developerCSS};
`
export const AssetInfoButton = styled.button`
  background: hsla(0, 0%, 100%, 0.1) url(${icons.info_icon}) center center / auto 10px no-repeat;
  padding: 10px;
  margin: 0 0 0 15px;
  border-radius: 6px;
  display: flex;
  width: fit-content;
  height: fit-content;
`
